import Vue from "vue";
import i18n from "@/i18n";
import VeeValidate, { Validator } from "vee-validate";
import esVee from "vee-validate/dist/locale/es";

const config = {
  events: "blur"
};

Vue.use(VeeValidate, config);

const language = i18n.locale;

switch (language) {
  case "es":
    Validator.localize("es", esVee);
    break;
  default:
    Validator.localize("en");
}
